// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--2i57J","title":"a10a3f92e9--title--2K523","text":"a10a3f92e9--text--cLoVd"};